import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import { ContextBoard } from "../../context/ContextBoard";

function TickerMaster() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [landingTickerText, setLandingTickerText] = useState("");
  const [deoTickerText, setDeoTickerText] = useState("");
  const permissions = JSON.parse(sessionStorage.getItem("permissions") || "[]");

  const [tickerId, setTickerId] = useState(null);
  const token = sessionStorage.getItem("secondaryAdminToken");
  useEffect(() => {
    if (!permissions[3]?.caN_VIEW) {
      navigate("/secondary-admin-dashboard");
    }
  }, [permissions, navigate]);
  useEffect(() => {
    if (!token) {
      navigate("/secondary-admin");
    } else {
      fetchTicker();
    }
  }, []);

  const fetchTicker = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/FetchAdminTickerMasterDataSecondary`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const data = await response.json();

      if (response.ok) {
        if (data.data?.tickerMaster_list?.length > 0) {
          const ticker = data.data.tickerMaster_list[0];
          setTickerId(ticker.id ?? 0);
          setLandingTickerText(ticker.title);
          setDeoTickerText(ticker.deO_TICKER_TITLE);
        }
      }
    } catch (error) {
      console.error("Error fetching ticker:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    /* if (landingTickerText.trim() === "") {
      Swal.fire("Warning", "Landing Ticker text cannot be empty!", "warning");
      return;
    } */
    /* if (deoTickerText.trim() === "") {
      Swal.fire("Warning", "Deo Ticker text cannot be empty!", "warning");
      return;
    } */
    setLoading(true);
    try {
      const response = await fetch(
        `${config.API_BASE_URL}/AdminInsertUpdateTickerMasterSecondary`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: tickerId ?? 0,
            title: landingTickerText,
            deO_TICKER_TITLE: deoTickerText,
            UPDATE_BY: sessionStorage.getItem("schoolCode") || "",
          }),
        }
      );

      const data = await response.json();

      if (response.ok && data.status === 200) {
        Swal.fire("Success", "Ticker updated successfully!", "success");
        fetchTicker();
      } else {
        Swal.fire("Error", data.message || "Failed to update ticker.", "error");
      }
    } catch (error) {
      console.error("Error saving ticker:", error);
      Swal.fire("Error", "An unexpected error occurred.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-scroller">
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <Navbar />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-12 mb-3">
                <section className="content-header">
                  <h1>
                    <i className="fa fa-university" />
                    &nbsp;Ticker Master
                  </h1>
                  <ol className="breadcrumb">
                    <li>
                      <a
                        onClick={() => navigate("/secondary-admin-dashboard")}
                        style={{ cursor: "pointer" }}
                      >
                        <i
                          className="fa fa-tachometer"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Home
                      </a>
                    </li>
                    <li className="active">Secondary Admin Ticker Master</li>
                  </ol>
                </section>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 mb-4 stretch-card">
                <div className="card">
                  <div className="card-header">
                    <h4 className="mb-0 p-2">Ticker Master</h4>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label className="fw-bold">
                            Landing Page Ticker Master : &nbsp;
                            {/* <span className="text-danger">*</span> */}
                          </label>
                          <textarea
                            className="form-control form-control-sm"
                            rows="7"
                            required
                            value={landingTickerText}
                            onChange={(e) =>
                              setLandingTickerText(e.target.value)
                            }
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group mb-3">
                          <label className="fw-bold">
                            DEO Dashboard Page Ticker Master : &nbsp;
                            {/* <span className="text-danger">*</span> */}
                          </label>
                          <textarea
                            className="form-control form-control-sm"
                            rows="7"
                            required
                            value={deoTickerText}
                            onChange={(e) => setDeoTickerText(e.target.value)}
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-12 stretch-card">
                <div className="card">
                  <div className="card-body">
                    <button
                      className="btn btn-primary me-2"
                      style={{ float: "right" }}
                      onClick={handleSave}
                      disabled={loading}
                    >
                      <i className="fa fa-save" />{" "}
                      {loading ? "Saving..." : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default TickerMaster;
